import React from "react";
import { Button } from "@mantine/core";
import { FaSyncAlt } from "react-icons/fa";

import { openapi } from "../../openapi";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { thunkToast } from "../DesignTab/designSlice";
import { selectProjectNo } from "../globalSelectors";
import { selectHttpSingleRoomFull } from "../Room/httpRoomSelectors";

function validationErrorMessage(error: unknown): string {
  const err = error as {
    data?: {
      message?: unknown;
      error?: { message?: unknown };
    };
    error?: unknown;
  };

  return typeof err?.data?.error?.message === "string"
    ? err.data.error.message
    : typeof err?.data?.message === "string"
      ? err.data.message
      : typeof err?.error === "string"
        ? err.error
        : "Kunne ikke revalidere forekomster for valgt rom.";
}

export const RevalidateDrofusOccurrenceValidationButton: React.FC = () => {
  const dispatch = useAppDispatch();
  const projectNo = useAppSelector(selectProjectNo);
  const room = useAppSelector(selectHttpSingleRoomFull);
  const [revalidate, { isLoading }] =
    openapi.usePostFunctionsDrofusRoomsOccurrencesValidateMutation();

  const disabled = !projectNo || !room?.roomNumber;

  const handleClick = async () => {
    if (!projectNo || !room?.roomNumber) return;

    try {
      const result = await revalidate({
        body: {
          projectNo,
          roomNumber: room.roomNumber,
        },
      }).unwrap();

      dispatch(
        thunkToast({
          header: "Forekomstvalidering oppdatert",
          text: `${result.roomNumber} validert på nytt`,
          isSuccess: true,
        })
      );
    } catch (error) {
      dispatch(
        thunkToast({
          header: "Kunne ikke revalidere",
          text: validationErrorMessage(error),
          isSuccess: false,
        })
      );
    }
  };

  return (
    <Button
      leftSection={<FaSyncAlt size={13} />}
      onClick={handleClick}
      loading={isLoading}
      disabled={disabled}
      variant="light"
      size="xs"
    >
      Revalider rom
    </Button>
  );
};
